
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

const module = {
  state: {
    formData: {},
    enableSearch: true,
    isLoaded: false,
  },

  getters: {},

  mutations: {},

  actions: {
    C30201_init ({ state }, payload) {
      state.enableSearch = false
      $this.$api.postData({
        data: [{ api: "T0062EntryControlService.C30201_getBatchEdit", input: state.searchInfo }]
      }).then(async(res) => {
        state.formData = res[0].output
        state.isLoaded = true
      })
    },
    async C30201_doBatchEdit ({ state }, payload) {
      const filteredFormData = {
        ...state.searchInfo,
        rows: Object.values(state.formData).filter((item) => item._t0062Selected === true)
      }
      await $this.$api.postData({
        data: [{ api: "T0062EntryControlService.C30201_doBatchEdit", input: filteredFormData }]
      }).then(async(res) => {
        state.formData = {}
        state.enableSearch = true
        state.isLoaded = false
      })
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
